import { useTranslation } from 'react-i18next';

import { Container, Row, TechContent } from './styles';

import ts from '../../assets/techs/ts.svg';
import java from '../../assets/techs/java.svg';
import nodejs from '../../assets/techs/nodejs.svg';
import nest from '../../assets/techs/nest.svg';
import spring from '../../assets/techs/spring.svg';

import react from '../../assets/techs/react.svg';
import prisma from '../../assets/techs/prisma.svg';
import postgresql from '../../assets/techs/postgresql.png';
import mongodb from '../../assets/techs/mongodb.png';
import docker from '../../assets/techs/docker.svg';

export function TechStack() {
  const { t } = useTranslation();

  return (
    <>
      <Container>
        <p>{t('my')} Tech Stack</p>
        <span>{t('techWorking')}</span>

        <TechContent>
          <Row >
            <a href="https://www.typescriptlang.org/" target="_blank">
              <img src={ts} alt='Typescript' />
            </a>
            <a href="https://www.java.com/pt-BR/" target="_blank">
              <img src={java} alt='Java' />
            </a>
            <a href="https://nodejs.org/en" target="_blank">
              <img src={nodejs} alt='NodeJS' />
            </a>
            <a href="https://nestjs.com/" target="_blank">
              <img src={nest} alt='NestJS' />
            </a>
            <a href="https://spring.io/" target="_blank">
              <img src={spring} alt='Spring' />
            </a>
          </Row>

          <Row>
            <a href="https://react.dev/" target="_blank">
              <img src={react} alt='react' />
            </a>
            <a href="https://www.prisma.io/" target="_blank">
              <img src={prisma} alt='Prisma.io' />
            </a>
            <a href="https://www.postgresql.org/" target="_blank">
              <img src={postgresql} alt='PostgreSQL' />
            </a>
            <a href="https://www.mongodb.com/" target="_blank">
              <img src={mongodb} alt='MongoDB' />
            </a>
            <a href="https://www.docker.com/" target="_blank">
              <img src={docker} alt='Docker' />
            </a>
          </Row>
        </TechContent>
      </Container>
    </>
  )
}